module.exports = __webpack_public_path__ + "img/assess_tools.5933a287.svg";